<mat-spinner [color]="spinnerColor()" [class]="sizeClass()"></mat-spinner>
